import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from './useInView';

const results = [
  { treatment: 'Lip Enhancement', area: 'Dermal Fillers', image: '/result-lip.webp' },
  { treatment: 'Full Face Transformation', area: 'Botox & Fillers', image: '/result-face-transform.webp' },
  { treatment: 'Facial Contouring', area: 'Jawline & Cheeks', image: '/result-contouring.webp' },
];

export default function Results() {
  const [ref, inView] = useInView({ threshold: 0.15 });

  return (
    <section id="results" ref={ref} className="section-padding bg-charcoal-950">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <div className="flex items-center justify-center gap-4 mb-6">
            <span className="w-12 h-px bg-gold-400/60" />
            <span className="text-xs tracking-[0.3em] uppercase text-gold-400 font-medium">
              Results
            </span>
            <span className="w-12 h-px bg-gold-400/60" />
          </div>
          <h2 className="heading-lg text-white mb-6">
            Real Results,{' '}
            <span className="italic text-gold-400">Real Confidence</span>
          </h2>
          <p className="text-charcoal-400 text-base md:text-lg leading-relaxed font-light">
            See the transformative outcomes our patients experience. Every
            result reflects Dr. Noora's commitment to natural-looking
            enhancements.
          </p>
        </motion.div>

        {/* Before/After grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {results.map((item, i) => (
            <motion.div
              key={item.treatment}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-charcoal-900 mb-4">
                {item.image ? (
                  <>
                    <img
                      src={item.image}
                      alt={`${item.treatment} before and after`}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-charcoal-950/60" />
                  </>
                ) : (
                  <>
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-charcoal-950/80" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="flex w-full h-full">
                        <div className="w-1/2 bg-charcoal-800 flex items-center justify-center border-r border-charcoal-700">
                          <span className="text-[10px] tracking-widest uppercase text-charcoal-500">
                            Before
                          </span>
                        </div>
                        <div className="w-1/2 bg-charcoal-800/60 flex items-center justify-center">
                          <span className="text-[10px] tracking-widest uppercase text-charcoal-400">
                            After
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-gold-500/0 group-hover:bg-gold-500/10 transition-colors duration-500" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
